import React from 'react';

interface AttackingDirectionControlsProps {
  teamName: string;
  attackingDirection: 'left' | 'right';
  normalizeToFirstHalf: boolean;
  onDirectionChange: (direction: 'left' | 'right') => void;
}

/**
 * AttackingDirectionControls - Controls for setting team attacking direction
 * Used in MapRenderer for both compare and single view modes
 */
const AttackingDirectionControls: React.FC<AttackingDirectionControlsProps> = ({
  teamName,
  attackingDirection,
  normalizeToFirstHalf,
  onDirectionChange,
}) => {
  return (
    <div className="flex items-center justify-center gap-3 mb-1">
      {/* Left Arrow */}
      <div className="flex flex-col items-center">
        <button
          onClick={() => onDirectionChange('left')}
          className="px-0.5 py-0 transition-all hover:opacity-80"
          title={normalizeToFirstHalf ? "Activate left attacking direction" : "Set 1st half to left"}
        >
          <span className={`text-3xl font-black ${
            normalizeToFirstHalf
              ? attackingDirection === 'left'
                ? 'text-black'
                : 'text-gray-300'
              : 'text-black'
          }`}>←</span>
        </button>
        {normalizeToFirstHalf ? (
          <div className={`text-[10px] mt-0 ${
            attackingDirection === 'left' ? 'text-gray-700 font-medium' : 'text-gray-300'
          }`}>
            Attacking Direction
          </div>
        ) : (
          <div className="text-[10px] mt-0 text-gray-700 font-medium">
            {attackingDirection === 'left' ? '1st Half' : '2nd Half'}
          </div>
        )}
      </div>
      
      {/* Team Label - Centered */}
      <div className="text-sm font-semibold text-gray-700 min-w-[120px] text-center">
        {teamName}
      </div>
      
      {/* Right Arrow */}
      <div className="flex flex-col items-center">
        <button
          onClick={() => onDirectionChange('right')}
          className="px-0.5 py-0 transition-all hover:opacity-80"
          title={normalizeToFirstHalf ? "Activate right attacking direction" : "Set 1st half to right"}
        >
          <span className={`text-3xl font-black ${
            normalizeToFirstHalf
              ? attackingDirection === 'right'
                ? 'text-black'
                : 'text-gray-300'
              : 'text-black'
          }`}>→</span>
        </button>
        {normalizeToFirstHalf ? (
          <div className={`text-[10px] mt-0 ${
            attackingDirection === 'right' ? 'text-gray-700 font-medium' : 'text-gray-300'
          }`}>
            Attacking Direction
          </div>
        ) : (
          <div className="text-[10px] mt-0 text-gray-700 font-medium">
            {attackingDirection === 'right' ? '1st Half' : '2nd Half'}
          </div>
        )}
      </div>
    </div>
  );
};

export default AttackingDirectionControls;

